export function isWindowAvailable() {
  return typeof window !== 'undefined';
}

export default isWindowAvailable;
